import { useRef, useState } from 'react'
import { browserLogger } from 'src/utils/browser-logger'
import { BaseParcelForLink, getParcelPropertyRecordsLink, getParcelZoningLink } from 'src/v2/utils/parcel'

export const useGetParcelLinks = (parcel?: BaseParcelForLink) => {
  const [loading, setLoading] = useState(false)
  const [notFound, setNotFound] = useState(false)
  const propertyRecordsLinkRef = useRef<string | undefined>()
  const zoningLinkRef = useRef<string | undefined>()

  const getParcelLinks = async () => {
    if (propertyRecordsLinkRef.current && zoningLinkRef.current) {
      return { propertyRecordsLink: propertyRecordsLinkRef.current, zoningLink: zoningLinkRef.current }
    }
    if (loading || notFound || !parcel) {
      return
    }
    setLoading(true)

    try {
      const propertyRecordsLink = await getParcelPropertyRecordsLink(parcel)
      const zoningLink = await getParcelZoningLink(parcel)

      if (!propertyRecordsLink && !zoningLink) {
        setNotFound(true)
        return
      }

      propertyRecordsLinkRef.current = propertyRecordsLink
      zoningLinkRef.current = zoningLink

      return { propertyRecordsLink, zoningLink }
    } catch (error) {
      setNotFound(true)
      browserLogger.error('Error getting parcel links', error)
    } finally {
      setLoading(false)
    }
  }

  return { getParcelLinks, loading, notFound }
}
